import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UiState {
  itemDrawerOpen: boolean;
  selectedItemId: string | null;
  isEditingOrder: boolean;
}

const initialState: UiState = {
  itemDrawerOpen: false,
  selectedItemId: null,
  isEditingOrder: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openItemDrawer(state, action: PayloadAction<{ itemId: string }>) {
      state.itemDrawerOpen = true;
      state.selectedItemId = action.payload.itemId;
    },
    closeItemDrawer(state) {
      state.itemDrawerOpen = false;
    },
    setEditingOrder(state, action: PayloadAction<boolean>) {
      state.isEditingOrder = action.payload;
    },
  },
});

export const { openItemDrawer, closeItemDrawer, setEditingOrder } =
  uiSlice.actions;
export default uiSlice.reducer;
